import messages from "@smartmixin/i18n/dist/translations/cs.json";

export default messages;
